import React, { useState, useContext } from 'react';
import { DEFAULT_VALIDATION_DELAY } from '../../../../configs/digital-funeral-configs/config';
import {
    OmFormInputFieldWrapper,
    OmApplicationBeneficiaryDetails,
    OmSideDrawer,OmSlider,
} from '@om/component-library-react';
import OmButton from '../../../../../../../components/forms/OmButton';
import { DigitalFuneralContext } from '../../context/DigitalFuneralContext';
import { isInputValid, areAllInputsInvalid, getFuneralPremium, generateString } from '../../../../utils/digital-funeral-utils/util';
const coverSlider = require('../../constants/refeferenceData/coverAmount');

const CoverSideDrawerSelf = () => {

    const { addCoverMemberToListLanding, myselfCoverDrawer, toggleMyselfCoverDrawer } = useContext(DigitalFuneralContext);

    const [coverMember, setCoverMember] = useState({relationship: 'Myself', age: undefined, coverAmt: '5000', coverAmtPremium: '0' })

    const resetMember = () => { setCoverMember({relationship: 'Myself', age: undefined, coverAmt: '5000', coverAmtPremium: '0'}) }

    const cancelAndCloseEditing = () => {
        resetMember();
        toggleMyselfCoverDrawer();
    };

    const handleChange = (e) => {
        const value = e.detail;
        const input = e.target.name;

        if(input === 'coverAmt'){
            setCoverMember({ ...coverMember, coverAmt: value, coverAmtPremium: getFuneralPremium(value, coverMember.age) })
        }else if (input === 'age') {
            setCoverMember({
                ...coverMember,
                age: value, 
                coverAmt: coverMember.coverAmt,
                coverAmtPremium: getFuneralPremium(coverMember.coverAmt, value) 
            }) 
        }else{
            setCoverMember({ ...coverMember, [input]: value });
        }  
    };

    const saveCoverMember = () => {
        addCoverMemberToListLanding({...coverMember, id: generateString(4).trim(), relationship: 'Myself'})
        cancelAndCloseEditing()
    };

    const dataToCheck = () => {
        return {
            relationship: 'Myself',
            coverAmt: coverMember?.coverAmt,
            age: coverMember?.age,
        }
    }


    return (
        <OmSideDrawer
            onOnSideDrawerClosed={() => {
                cancelAndCloseEditing()
            }}
            open={myselfCoverDrawer}
        >
            <div slot="side-drawer-content">
                <OmApplicationBeneficiaryDetails>
                    <div slot="om-application-beneficiary-details">
                        <div>
                            <h5 className="no-top-margin side-drawer-header" id="beneficiaries-side-drawer">
                                <strong>Me Alone </strong>
                            </h5>

                            <OmFormInputFieldWrapper
                                label="Age"
                                id="age"
                                name="age"
                                placeholder="eg 18"
                                labelAlwaysShow={true}
                                required
                                formId="coverMemberForm"
                                size="full"
                                align="left"
                                type="number"
                                validationDelay={DEFAULT_VALIDATION_DELAY}
                                value={coverMember?.age}
                                state={isInputValid(coverMember?.age)}
                                errorMessage={isInputValid(coverMember?.age) === 'error' ? 'Please enter your age. Eg 18' : undefined }
                                onPersist={(e) => handleChange(e)}
                            />


                            <p>Cover Amount: </p>
                            <OmSlider
                                stepString={JSON.stringify(coverSlider.COVER_SLIDER_AMOUNTS)}
                                name="coverAmt"
                                minLabel="₵2,000"
                                maxLabel="₵20,000"
                                value={coverMember?.coverAmt}
                                valuePrefix="₵"
                                onSliderChange={(e) => handleChange(e)}
                            />


                        </div>

                        <div className="action-buttons">
                            <OmButton
                                className="cancel-button"
                                type="text"
                                size="small"
                                text="CANCEL"
                                onClick={() => cancelAndCloseEditing()}
                            />

                            <OmButton
                                disabled={!areAllInputsInvalid(dataToCheck())}
                                className="save-button"
                                type="primary"
                                size="small"
                                text="ADD TO QUOTE"
                                onClick={() => saveCoverMember()}
                            />
                        </div>
                    </div>
                </OmApplicationBeneficiaryDetails>
            </div>
        </OmSideDrawer>
    );
};

export default CoverSideDrawerSelf;
